module.exports = __webpack_public_path__ + "img/ejemplo-vida-laboral.95cc0259.svg";